import { forwardRef, type ComponentPropsWithoutRef } from "react";

import { cn } from "@/shared/lib/utils";

import { Textarea } from "../primitives/textarea";

interface ColocaTextareaProps extends Omit<ComponentPropsWithoutRef<"textarea">, "value" | "onChange"> {
  value: string;
  onValueChange: (value: string) => void;
}

// Standalone (not RHF-bound) — use `ColocaTextareaField` for form-bound multi-line text.
export const ColocaTextarea = forwardRef<HTMLTextAreaElement, ColocaTextareaProps>(function ColocaTextarea(
  { value, onValueChange, className, ...rest },
  ref,
) {
  return (
    <Textarea
      ref={ref}
      value={value}
      onChange={(event) => onValueChange(event.target.value)}
      className={cn(className)}
      {...rest}
    />
  );
});
